import {RegisterForm} from './form';
export default RegisterForm;